import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "Nueva Historia",
    ongoingStories: "Historias en Curso",
    completedStories: "Historias Terminadas",
    loadingStory: "Cargando Historia",
    pleaseWait: "Por favor espere mientras cargamos su historia",
    newCharacter: "Nuevo Personaje",
    characterCard: {
      personality: "Personalidad",
      strengths: "Fortalezas",
      weaknesses: "Debilidades",
      skills: "Habilidades"
    },
    search: {
      placeholder: "Buscar historias por título...",
      characters: "Buscar personajes..."
    },
    filters: {
      title: "Filtros",
      reset: "Restablecer",
      apply: "Aplicar",
      sortBy: "Ordenar por",
      filterByRole: "Filtrar por rol",
      name: "Nombre",
      role: "Rol",
      dateCreated: "Fecha de creación",
      rating: "Calificación", // Added missing key
      allRoles: "Todos los Roles",
      roles: {
        all: "Todos los roles",
        protagonist: "Personaje principal",
        antagonist: "Antagonista",
        deuteragonist: "Personaje secundario",
        mentor: "Mentor",
        comic_relief: "Alivio cómico",
        mysterious: "Figura misteriosa",
        love_interest: "Interés amoroso",
        anti_hero: "Antihéroe",
        sidekick: "Compañero",
        shapeshifter: "Cambiaformas",
        guardian: "Guardián",
        catalyst: "Catalizador",
        character: "Personaje",
        supporting: "Personaje de Apoyo"
      }
    },
    deleteStory: {
      confirmTitle: "Eliminar Historia",
      confirmMessage: "¿Estás seguro de que quieres eliminar esta historia? Esta acción no se puede deshacer.",
      success: "Historia Eliminada",
      successMessage: "La historia ha sido eliminada exitosamente.",
      error: "Error",
      errorMessage: "Error al eliminar la historia. Por favor intenta de nuevo."
    },
    navigation: {
      stories: "Historias",
      characters: "Personajes",
      publicStories: "Historias Públicas",
      stats: "Estadísticas",
      more: "Más"
    },
    loadingCharacters: "Cargando personajes...",
    noCharactersFound: "No se encontraron personajes",
    createCharacter: {
      title: "Crear Nuevo Personaje",
      editTitle: "Editar Personaje",
      basicDetails: "Detalles Básicos",
      characteristics: "Características",
      avatarDetails: "Detalles del Avatar",
      personalityTraits: "Rasgos de Personalidad",
      form: {
        name: "Nombre",
        namePlaceholder: "Ingrese el nombre del personaje",
        description: "Descripción",
        descriptionPlaceholder: "Ingrese la descripción del personaje",
        role: "Rol",
        selectRole: "Seleccione el rol del personaje",
        personality: "Personalidad",
        personalityTraits: "Rasgos de Personalidad",
        personalityPlaceholder: "Ingrese rasgos de personalidad",
        strengths: "Fortalezas",
        strengthsPlaceholder: "Ingrese las fortalezas del personaje",
        weaknesses: "Debilidades",
        weaknessesPlaceholder: "Ingrese las debilidades del personaje",
        skills: "Habilidades",
        skillsPlaceholder: "Ingrese las habilidades del personaje",
        addTrait: "Agregar Rasgo",
        addStrength: "Agregar Fortaleza",
        addWeakness: "Agregar Debilidad",
        addSkill: "Agregar Habilidad",
        "add.Personality.Traits": "Agregar Rasgos de Personalidad",
        "add.Strengths": "Agregar Fortalezas",
        "add.Weaknesses": "Agregar Debilidades",
        "add.Skills": "Agregar Habilidades",
        unnamedCharacter: "Personaje Sin Nombre",
        cancel: "Cancelar",
        create: "Crear Personaje",
        update: "Actualizar Personaje"
      },
      buttons: {
        create: "Crear Personaje",
        update: "Actualizar Personaje",
        cancel: "Cancelar",
        updating: "Actualizando...",
        creating: "Creando...",
      },
      avatarGenerator: {
        genderLabel: "Género/Apariencia",
        genderPlaceholder: "Seleccionar género",
        ageLabel: "Grupo de Edad",
        agePlaceholder: "Seleccionar grupo de edad",
        hairLabel: "Descripción del Cabello",
        hairPlaceholder: "ej., Cabello negro rizado largo",
        eyeLabel: "Color de Ojos",
        eyePlaceholder: "ej., Azul profundo",
        clothingLabel: "Estilo de Vestimenta",
        clothingPlaceholder: "ej., Armadura medieval",
        expressionLabel: "Expresión Facial",
        expressionPlaceholder: "ej., Sonrisa confiada",
        generateButton: "Generar Avatar",
        generating: "Generando...",
        previewLabel: "Avatar Generado",
        selectTitle: "Seleccionar Avatar",
        selectDescription: "Elige uno de los avatares generados para tu personaje.",
        partialSuccess: "Algunas imágenes no se pudieron cargar",
        someImagesFailed: "Algunas imágenes no se pudieron cargar. Inténtalo de nuevo.",
        selectPreferred: "Seleccione su avatar preferido",
        genderOptions: {
          male: "Humano - Masculino",
          female: "Humano - Femenino",
          // New animal options
          cat: "Animal - Gato",
          dog: "Animal - Perro",
          wolf: "Animal - Lobo",
          fox: "Animal - Zorro",
          rabbit: "Animal - Conejo",
          bird: "Animal - Pájaro",
          reptile: "Animal - Reptil",
          // Existing fantasy options
          elf: "Fantasía - Elfo",
          dwarf: "Fantasía - Enano",
          orc: "Fantasía - Orco",
          vampire: "Fantasía - Vampiro",
          werewolf: "Fantasía - Hombre Lobo",
          fairy: "Fantasía - Hada",
          angelic: "Fantasía - Ser Angelical",
          demonic: "Fantasía - Ser Demoníaco",
          dragonborn: "Fantasía - Nacido de Dragón",
          centaur: "Fantasía - Centauro",
          mermaid: "Fantasía - Sirena/Tritón",
          humanoid_alien: "Ciencia Ficción - Alienígena Humanoide",
          insectoid_alien: "Ciencia Ficción - Alienígena Insectoide",
          reptilian_alien: "Ciencia Ficción - Alienígena Reptiliano",
          cyborg: "Ciencia Ficción - Robot/Cyborg",
          energy_being: "Ciencia Ficción - Ser de Energía",
          tentacled: "Ciencia Ficción - Criatura Tentacular",
          cat_person: "Animal - Persona Gato",
          dog_person: "Animal - Persona Perro",
          wolf_person: "Animal - Persona Lobo",
          fox_person: "Animal - Persona Zorro",
          rabbit_person: "Animal - Persona Conejo",
          bird_person: "Animal - Persona Pájaro",
          reptile_person: "Animal - Persona Reptil",
          treant: "Mítico - Árbol Andante",
          flower: "Mítico - Flor Consciente",
          vine: "Mítico - Enredadera Viviente",
          mushroom: "Mítico - Hongo Parlante",
          vegetable: "Mítico - Planta Animada",
          golem: "Mítico - Gólem",
          ghost: "Mítico - Fantasma/Espíritu",
          shapeshifter: "Mítico - Cambiaformas"
        },
        ageOptions: {
          child: "Niño",
          teen: "Adolescente",
          adult: "Adulto",
          elderly: "Anciano"
        },
        success: {
          title: "Avatar Generado",
          description: "El avatar de tu personaje ha sido creado exitosamente."
        },
        error: {
          title: "Error de Generación",
          description: "Error al generar el avatar. Por favor intenta de nuevo."
        },
        upload: {
          button: "Subir Avatar",
          uploading: "Subiendo...",
          success: {
            title: "Avatar subido",
            description: "Tu avatar ha sido subido exitosamente"
          },
          error: {
            title: "Error al subir",
            fileTooLarge: "La imagen del avatar debe ser menor de 5MB",
            invalidType: "Por favor sube un archivo de imagen",
            failed: "Error al subir la imagen del avatar"
          },
          loading: "Cargando imagen..."
        }
      },
      new: "Nuevo Personaje",
      messages: {
        successCreated: {
          title: "Personaje Creado",
          description: "Tu personaje ha sido creado exitosamente.",
        },
        successUpdated: {
          title: "Personaje Actualizado",
          description: "Tu personaje ha sido actualizado exitosamente.",
        },
        errorLoad: {
          title: "Error",
          description: "Error al cargar el personaje. Por favor intenta de nuevo.",
        },
        errorSave: {
          title: "Error",
          description: "Error al guardar el personaje. Por favor intenta de nuevo.",
        },
        validation: {
          characterName: {
            title: "Nombre del Personaje",
            description: "Por favor ingresa un nombre para el personaje.",
          },
        },
      },
    },
    characterTabs: {
      myCharacters: "Mis Personajes",
      publicCharacters: "Personajes Públicos"
    },
    suggestions: {
      personalities: {
        adaptable: "Adaptable",
        ambitious: "Ambicioso",
        brave: "Valiente",
        charismatic: "Carismático",
        compassionate: "Compasivo",
        confident: "Seguro",
        creative: "Creativo",
        determined: "Determinado",
        diplomatic: "Diplomático",
        empathetic: "Empático",
        honorable: "Honorable",
        humble: "Humilde",
        humorous: "Humorístico",
        innovative: "Innovador",
        loyal: "Leal",
        optimistic: "Optimista",
        patient: "Paciente",
        resilient: "Resiliente",
        wise: "Sabio",
        analytical: "Analítico",
        cautious: "Cauteloso",
        eccentric: "Excéntrico",
        mysterious: "Misterioso",
        pragmatic: "Pragmático",
        reserved: "Reservado",
        stoic: "Estoico",
        arrogant: "Arrogante",
        cynical: "Cínico",
        greedy: "Codicioso",
        hot_tempered: "Temperamental",
        impulsive: "Impulsivo",
        manipulative: "Manipulador",
        obsessive: "Obsesivo",
        paranoid: "Paranoico",
        prideful: "Orgulloso",
        reckless: "Imprudente",
        ruthless: "Despiadado",
        vengeful: "Vengativo"
      },
      skills: {
        leadership: "Liderazgo",
        negotiation: "Negociación",
        perception: "Percepción",
        persuasion: "Persuasión",
        investigation: "Investigación",
        survival: "Supervivencia",
        deception: "Engaño",
        intimidation: "Intimidación",
        performance: "Actuación",
        medicine: "Medicina",
        sword_fighting: "Esgrima",
        archery: "Tiro con Arco",
        martial_arts: "Artes Marciales",
        stealth: "Sigilo",
        acrobatics: "Acrobacia",
        marksmanship: "Puntería",
        hand_to_hand: "Combate Cuerpo a Cuerpo",
        tactical: "Planificación Táctica",
        magic: "Magia",
        elemental_control: "Control Elemental",
        healing: "Curación Mágica",
        necromancy: "Nigromancia",
        prophecy: "Profecía",
        shapeshifting: "Cambiaformas",
        telepathy: "Telepatía",
        telekinesis: "Telequinesis",
        alchemy: "Alquimia",
        summoning: "Invocación",
        hacking: "Hackeo",
        piloting: "Pilotaje",
        robotics: "Robótica",
        cybernetics: "Cibernética",
        nanotech: "Nanotecnología",
        quantum_physics: "Física Cuántica",
        ai_programming: "Programación de IA",
        bioengineering: "Bioingeniería",
        time_manipulation: "Manipulación del Tiempo",
        energy_weapons: "Armas de Energía",
        crafting: "Artesanía",
        cooking: "Cocina",
        music: "Música",
        art: "Arte",
        writing: "Escritura",
        forgery: "Falsificación",
        invention: "Invención",
        linguistics: "Lingüística",
        history: "Historia",
        science: "Ciencia",
        psychology: "Psicología",
        archaeology: "Arqueología",
        cryptography: "Criptografía",
        strategy: "Estrategia",
        mythology: "Mitología",
        economics: "Economía"
      }
    },
    publicStories: "Historias Públicas",
    upgradeForMore: "Actualizar para más",
    storiesRemaining: "historias restantes hoy",
    storiesAvailable: "historias disponibles hoy",
    by: "por",
    anonymous: "Anónimo",
    completed: "Completada",
    public: "Pública",
    makePublic: "Hacer pública",
    makePrivate: "Hacer privada",
    upgradeToMakePublic: "Actualiza para hacer públicas tus historias",
    error: "Error",
    rating: {
      submitted: "Calificación enviada",
      thankYou: "¡Gracias por calificar esta historia!",
      failed: "No se pudo enviar la calificación"
    },
    upgrade: {
      required: "Actualización Requerida",
      description: "Actualiza tu cuenta para hacer públicas tus historias y compartirlas con otros.",
      shareStories: "Comparte tus historias con una suscripción premium",
      now: "Actualizar Ahora"
    },
    startedTime: "Iniciada {{time}}",
    storyVisibility: {
      madePublic: "Historia hecha pública",
      madePrivate: "Historia hecha privada", 
      publicDescription: "Otros ahora pueden ver esta historia",
      privateDescription: "Esta historia ahora es privada"
    },
    characterManagement: {
      delete: {
        title: "Eliminar Personaje",
        confirmMessage: "¿Estás seguro de que quieres eliminar este personaje? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        delete: "Eliminar",
        deleting: "Eliminando...",
        success: {
          title: "Personaje eliminado",
          description: "El personaje ha sido eliminado exitosamente"
        },
        error: {
          title: "Error",
          description: "Error al eliminar el personaje"
        }
      },
      visibility: {
        setPrivate: "Personaje configurado como privado",
        setPublic: "Personaje configurado como público",
        nowPrivate: "El personaje ahora es privado",
        nowPublic: "El personaje ahora es visible para todos",
        error: "Error",
        updateFailed: "Error al actualizar la visibilidad del personaje"
      },
      rating: {
        submitted: "Calificación enviada",
        thankYou: "¡Gracias por calificar este personaje!",
        error: "Error",
        failed: "Error al enviar la calificación"
      }
    },
    stats: {
      tabs: {
        badges: "Insignias",
        stories: "Historias",
        characters: "Personajes",
        engagement: "Participación"
      },
      badges: {
        loading: "Cargando insignias...",
        earned: "Obtenido:",
        error: {
          title: "Error",
          loadBadges: "Error al cargar las insignias",
          loadProgress: "Error al cargar el progreso de las insignias"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "Escritor Prolífico",
            description: "Completa 100 historias",
            category: "Escritura"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "Novelista Histórico",
            description: "Completa 3 historias de ficción histórica",
            category: "Géneros"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "Escritor de Resistencia",
            description: "Escribe respuestas durante 30+ días seguidos",
            category: "Escritura"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "Resolutor de Misterios",
            description: "Completa 10 historias de misterio",
            category: "Géneros"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "Arquitecto de Diálogos",
            description: "Contribuir con 10,000 palabras de diálogo a través de interacciones",
            category: "Escritura"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "Crítico Superior",
            description: "Califica 20 personajes",
            category: "Comunidad"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "Constructor de Relaciones",
            description: "Crea relaciones entre 5 personajes",
            category: "Personajes"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "Sensación Viral",
            description: "Una historia obtiene más de 1,000 vistas",
            category: "Social"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "Pensador Profundo",
            description: "Agrega una historia detallada a 3 personajes",
            category: "Personajes"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "Mariposa Social",
            description: "Califica 20 historias",
            category: "Comunidad"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "Aficionado al Terror",
            description: "Completa 20 historias de terror",
            category: "Géneros"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "Iniciador de Series",
            description: "Publica la primera historia en una serie de varias partes",
            category: "Escritura"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "Voz Equilibrada",
            description: "Logra más respuestas editadas por el usuario",
            category: "Escritura"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "Maestro de Referencias",
            description: "Invita y consigue que 10 amigos se unan",
            category: "Social"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "Alentador",
            description: "Da 20+ reacciones positivas a las historias",
            category: "Comunidad"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "Maestro de Indicaciones",
            description: "Proporciona 100 indicaciones únicas de usuario",
            category: "Escritura"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "Promotor",
            description: "Comparte 5 historias en redes sociales",
            category: "Social"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "Susurrador de IA",
            description: "Acepta respuestas generadas por IA 500 veces",
            category: "Escritura"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "Artista de Personajes",
            description: "Generar un avatar para un personaje",
            category: "Personajes"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "Escritor Diario",
            description: "Crear una historia durante 7 días consecutivos",
            category: "Escritura"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "Elenco Dinámico",
            description: "Usa 20+ personajes diferentes en las historias",
            category: "Personajes"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "Experimentador",
            description: "Completa en 10+ géneros diferentes en las historias",
            category: "Géneros"
          }
        }
      },
      storyStats: {
        loading: "Cargando estadísticas...",
        totalStories: "Total de Historias",
        completed: "Completadas",
        published: "Publicadas",
        averageRating: "Calificación Promedio",
        categoryRelationships: "Relaciones entre Categorías",
        primaryCategory: "Categoría Principal",
        secondaryCategory: "Categoría Secundaria",
        selectCategory: "Seleccionar categoría",
        genre: "Género",
        themes: "Temas",
        environment: "Ambiente",
        noCategoryData: "No hay datos de categorías disponibles",
        lessFrequent: "Menos frecuente",
        moreFrequent: "Más frecuente",
        usageDescription: "Muestra con qué frecuencia se usan juntas las categorías en tus historias",
        stories: "historias",
        noDataAvailable: "No hay datos disponibles",
      },
      characterStats: {
        loading: "Cargando estadísticas de personajes...",
        totalCharacters: "Total de Personajes",
        publicCharacters: "Personajes Públicos",
        averageRating: "Calificación Promedio",
        traitRelationships: "Relaciones entre Rasgos de Personaje",
        primaryTraitType: "Tipo de Rasgo Principal",
        secondaryTraitType: "Tipo de Rasgo Secundario",
        selectTraitType: "Seleccionar tipo de rasgo",
        personalityTraits: "Rasgos de Personalidad",
        strengths: "Fortalezas",
        weaknesses: "Debilidades",
        skills: "Habilidades",
        noTraitData: "No hay datos de relación de rasgos disponibles",
        lessFrequent: "Menos frecuente",
        moreFrequent: "Más frecuente",
        usageDescription: "Muestra con qué frecuencia aparecen juntos diferentes rasgos en tus personajes",
        characters: "personajes"
      },
      engagementStats: {
        loading: "Cargando estadísticas...",
        totalStories: "Total de Historias",
        avgCustomization: "Personalización Promedio",
        avgWordCount: "Promedio de Palabras",
        currentStreak: "Racha Actual",
        days: "días",
        monthlyProgress: "Progreso Mensual"
      }
    },
    author: {
      title: 'Perfil del Autor',
      credits: 'Créditos de Historia',
      creditsAvailable: 'Tienes {{count}} créditos disponibles',
      memberSince: 'Miembro de TaleCraft',
      loading: 'Cargando...',
      recentBadges: 'Insignias Recientes',
      noBadgesYet: 'Aún no se han ganado insignias',
      earnedOn: 'Ganado el {{date}}',
      more: 'más'
    },
    access: {
      restricted: "Acceso Restringido",
      loginRequired: "Se requiere inicio de sesión para acceder a esta página.",
    }
  }
};
